import React from 'react';

export default function InfoTooltip({ label }) {
  return (
    <span
      className="info-tooltip"
      role="img"
      aria-label={label}
      title={label}
      style={{ cursor: 'help', marginLeft: 6, userSelect: 'none' }}
    >
      🛈
    </span>
  );
}
